export default __webpack_public_path__ + "static/media/flow-logo.f7754e2c.png";